import { useMemo, useState } from 'react';
import { useChatSearchQuery } from '../api/use-chat-search-query';
import { SEARCH_STRATEGY } from './constants';

export const useChatSearch = (chats, strategy = SEARCH_STRATEGY.FRONTEND) => {
  const [query, setQuery] = useState('');
  const backendSearch = useChatSearchQuery(query, {
    enabled: strategy === SEARCH_STRATEGY.BACKEND && !!query.trim(),
  });

  const filteredChats = useMemo(() => {
    if (strategy === SEARCH_STRATEGY.BACKEND) {
      return backendSearch.data?.data?.chats || backendSearch.data || chats;
    }

    const normalized = query.trim().toLowerCase();
    if (!normalized) return chats;

    return chats.filter((chat) => {
      const participant = chat.participants?.[0];
      const name = (participant?.name || '').toLowerCase();
      const lastMessage = (chat.last_message?.data || '').toLowerCase();
      return name.includes(normalized) || lastMessage.includes(normalized);
    });
  }, [chats, query, strategy, backendSearch.data]);

  return {
    query,
    setQuery,
    filteredChats,
    isLoading: strategy === SEARCH_STRATEGY.BACKEND ? backendSearch.isLoading : false,
  };
};
